import React from "react";

const EventCard = ({ date, name, description, onClick }) => {
  return (
    <div className="event-card" onClick={onClick} style={{ cursor: "pointer" }}>
      <div className="event-date">{date}</div>

      <div className="event-name-tab">
        <h4>{name}</h4>
        <p className="event-description">{description}</p>
      </div>
    </div>
  );
};

export default EventCard;
